import { usePermissions } from "components/context/permissionsContext";

export const usePaymentPermission = () => {
  const { userPermissions } = usePermissions();

  const hasPaymentSavePermission = userPermissions.some(
    (item) =>
      item.module === "Payment" &&
      item.controller === "Payment" &&
      item.action === "Save" &&
      item.hasPermission
  );
  const hasPaymentGetPermission = userPermissions.some(
    (item) =>
      item.module === "Payment" &&
      item.controller === "Payment" &&
      item.action === "Get" &&
      item.hasPermission
  );
  const hasPaymentDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Payment" &&
      item.controller === "Payment" &&
      item.action === "Delete" &&
      item.hasPermission
  );

  const PaymentPermissionProps = {
    hasPaymentSavePermission,
    hasPaymentGetPermission,
    hasPaymentDeletePermission
  };

  return {
    PaymentPermissionProps,
  };
};
